"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var core_1 = require("@bodiless/core");

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var Chameleon_1 = require("./Chameleon");

var SafeFragment = core_1.withOnlyProps('key', 'children')(react_1.Fragment);
var SafeSpan = fclasses_1.withoutProps('href')('span');

var extendOverrides = function extendOverrides(useOverrides) {
  if (useOverrides === void 0) {
    useOverrides = function useOverrides() {
      return {};
    };
  }

  return function (extender) {
    if (extender === void 0) {
      extender = function extender() {
        return {};
      };
    }

    return function (props) {
      return __assign(__assign({}, useOverrides(props)), extender(props));
    };
  };
};
/**
 * @private
 * Default hoc used to replace link when toggled off.
 */


var defaultAsOff = lodash_1.flow(core_1.ifEditable(fclasses_1.replaceWith(SafeSpan)), core_1.ifReadOnly(fclasses_1.replaceWith(SafeFragment)));
/**
 * Creates an AsBodiless... HOC factory which can be used to wrap a component
 * in a toggled bodiless link.
 *
 * @param asEditableLink
 * HOC factory which should be used to create the plain link.
 *
 * @param asOff
 * Optional HOC to apply when the link is toggled off.  By default, replaces the
 * wrapped component with a fragment (or with a span in edit mode).
 */

var withBodilessLinkToggle = function withBodilessLinkToggle(asEditableLink, asOff) {
  if (asOff === void 0) {
    asOff = defaultAsOff;
  }

  return function (nodeKey, defaultData, useOverrides) {
    var useOverrides$ = extendOverrides(function () {
      return {
        label: Chameleon_1.useChameleonContext().isOn ? 'Edit' : 'Add',
        formTitle: Chameleon_1.useChameleonContext().isOn ? 'Edit Link' : 'Add Link'
      };
    })(useOverrides);
    return lodash_1.flowRight(fclasses_1.withDesign({
      _default: asOff,
      Link: lodash_1.identity
    }), Chameleon_1.withChameleonContext('link-toggle'), Chameleon_1.withChameleonComponentFormControls, core_1.withSidecarNodes(lodash_1.flowRight(core_1.ifEditable(Chameleon_1.withDeleteNodeOnUnwrap(nodeKey)), asEditableLink(nodeKey, defaultData, useOverrides$))), Chameleon_1.applyChameleon);
  };
};

exports.default = withBodilessLinkToggle;